import { Button } from "@/ui-components/ui/button";
import { AuroraBackground } from "@/ui-components/ui/shadcn-io/aurora-background";
import { AlertCircle, LogIn, UserPlus } from "lucide-react";
import { useAuth0 } from "@auth0/auth0-react";

const UserNotFoundPage = () => {
  const { logout } = useAuth0();

  const handleLogin = () => {
    logout({
      logoutParams: {
        returnTo: window.location.origin,
      },
    });
  };

  const handleRegister = () => {
    logout({
      logoutParams: {
        returnTo: `${window.location.origin}/register`,
      },
    });
  };

  return (
    <div className="h-screen w-full bg-white text-black">
      <AuroraBackground variant="blue">
        <div className="w-full max-w-2xl px-6 relative z-10">
          <div className="mx-auto flex flex-col items-center text-center">
            <div className="mb-6 grid place-items-center rounded-2xl bg-white/70 p-4 ring-1 ring-black/5 backdrop-blur">
              <AlertCircle className="h-9 w-9 text-blue-600" />
            </div>

            <h3 className="text-xl font-bold text-gray-900 mb-2 tracking-tight">Nutzer wurde nicht gefunden</h3>
            <p className="text-gray-500 max-w-md mx-auto leading-relaxed">
              Dein Login ist noch aktiv, aber zu diesem Account gibt es in SportyPost keinen Nutzer mehr.
              Melde dich neu an oder registriere einen neuen Account.
            </p>

            <div className="flex flex-col sm:flex-row gap-2 justify-center w-full mt-6">
              <Button
                onClick={handleLogin}
                variant="outline"
                className="w-full sm:w-auto h-11 px-8 rounded-xl border-gray-200 bg-white/80 hover:bg-white"
              >
                <LogIn className="w-4 h-4 mr-2" />
                Anmelden
              </Button>
              <Button
                onClick={handleRegister}
                className="w-full sm:w-auto h-11 px-8 rounded-xl bg-blue-600 hover:bg-blue-700 text-white shadow-sm transition-all"
              >
                <UserPlus className="w-4 h-4 mr-2" />
                Registrieren
              </Button>
            </div>
          </div>
        </div>
      </AuroraBackground>
    </div>
  );
};

export default UserNotFoundPage;
